import { AvailableLanguageListType } from '@vallourec-ui/vallourec-ui'

import { SiteProps } from '@/@types/global'

export const LANGUAGES: AvailableLanguageListType[] = ['en-US', 'pt-BR', 'fr']

export const SITES: SiteProps[] = [
  {
    id: 1,
    name: 'Barreiro',
    code: 'B',
    address:
      'Avenida Olinto Meireles 65 CEP: 30640-010 - Belo Horizonte - MG / Brasil',
    phone: '+55 31 2141-5773',
  },
  {
    id: 2,
    name: 'Jeceaba',
    code: 'J',
    address:
      'Rua Industrial S/N - Distrito Industrial - CEP 35498-000 - Jeceaba - MG / Brasil',
    phone: '+55 31 2141-5124',
  },
]

export const TESTS = [
  {
    key: 1,
    name: 'Flattening',
    namePt: 'Achatamento',
    type: 2,
    typeCode: 'mechanical',
    id: 'flattening',
    code: 'test.flattening',
    sites: ['J', 'B'],
  },
  {
    key: 2,
    name: 'Flaring',
    namePt: 'Alargamento',
    type: 2,
    typeCode: 'mechanical',
    id: 'flaring',
    code: 'test.flaring',
    sites: ['J', 'B'],
  },
  {
    key: 3,
    name: 'Copper Layer',
    namePt: 'Camada de Cobre',
    type: 3,
    typeCode: 'metallographic',
    id: 'copper_layer',
    code: 'test.copper.layer',
    sites: ['J', 'B'],
    selectOne: true,
  },
  {
    key: 4,
    name: 'Collapse',
    namePt: 'Colapso',
    type: 6,
    typeCode: 'collapse',
    id: 'collapse',
    code: 'test.collapse',
    sites: ['J', 'B'],
  },
  {
    key: 5,
    name: 'CTOD',
    namePt: 'CTOD',
    type: 2,
    typeCode: 'mechanical',
    id: 'ctod',
    code: 'test.ctod',
    sites: ['J', 'B'],
    selectOne: true,
  },
  {
    key: 6,
    name: 'Bending',
    namePt: 'Dobramento',
    type: 2,
    typeCode: 'mechanical',
    id: 'bending',
    code: 'test.bending',
    sites: ['J', 'B'],
  },
  {
    key: 7,
    name: 'Hardness',
    namePt: 'Dureza',
    type: 2,
    typeCode: 'mechanical',
    id: 'hardness',
    code: 'test.hardness',
    sites: ['J', 'B'],
  },
  {
    key: 8,
    name: 'Four Point',
    namePt: 'Four Point',
    type: 4,
    typeCode: 'corrosion',
    id: 'four_point',
    code: 'test.four.point',
    sites: ['J', 'B'],
  },
  {
    key: 9,
    name: 'HIC',
    namePt: 'HIC',
    type: 4,
    typeCode: 'corrosion',
    id: 'hic',
    code: 'test.hic',
    sites: ['J', 'B'],
  },
  {
    key: 10,
    name: 'Impact - Transversal',
    namePt: 'Impacto Transversal',
    type: 2,
    typeCode: 'mechanical',
    id: 'impact_transversal',
    code: 'test.impact.transversal',
    sites: ['J', 'B'],
  },
  {
    key: 11,
    name: 'Impact - Longitudinal',
    namePt: 'Impacto Longitudinal',
    type: 2,
    typeCode: 'mechanical',
    id: 'impact_longitudinal',
    code: 'test.impact.longitudinal',
    sites: ['J', 'B'],
  },
  {
    key: 12,
    name: 'Microhardness',
    namePt: 'Microdureza',
    type: 3,
    typeCode: 'metallographic',
    id: 'microhardness',
    code: 'test.microhardness',
    sites: ['J', 'B'],
  },
  {
    key: 13,
    name: 'Microstructure',
    namePt: 'Microestrutura',
    type: 3,
    typeCode: 'metallographic',
    id: 'microstructure',
    code: 'test.microstructure',
    sites: ['J', 'B'],
  },
  {
    key: 14,
    name: 'Microstructure with photos',
    namePt: 'Microestrutura (fotos)',
    type: 3,
    typeCode: 'metallographic',
    id: 'microstructure_photos',
    code: 'test.microstructure.with.photos',
    sites: ['J', 'B'],
    selectOne: true,
  },
  {
    key: 15,
    name: 'Micro Cleanliness',
    namePt: 'Micro Pureza',
    type: 3,
    typeCode: 'metallographic',
    id: 'micro_cleanliness',
    code: 'report.cleanliness',
    sites: ['J', 'B'],
  },
  {
    key: 16,
    name: 'NACE-A',
    namePt: 'Nace A',
    type: 4,
    typeCode: 'corrosion',
    id: 'nace_a',
    code: 'test.nace.a',
    sites: ['J', 'B'],
  },
  {
    key: 17,
    name: 'NACE-D',
    namePt: 'Nace D',
    type: 4,
    typeCode: 'corrosion',
    id: 'nace_d',
    code: 'test.nace.d',
    sites: ['J', 'B'],
  },
  {
    key: 18,
    name: 'MPI',
    namePt: 'Partícula Magnética',
    type: 2,
    typeCode: 'ndt',
    id: 'mpi',
    code: 'test.mpi',
    sites: ['J', 'B'],
    selectOne: true,
  },
  {
    key: 19,
    name: 'Chemical',
    namePt: 'Químico',
    type: 5,
    typeCode: 'chemical',
    id: 'chemical',
    code: 'test.chemical',
    sites: ['J', 'B'],
  },
  {
    key: 20,
    name: 'Reeling',
    namePt: 'Reeling',
    type: 2,
    typeCode: 'mechanical',
    id: 'reeling',
    code: 'test.reeling',
    sites: ['J', 'B'],
    selectOne: true,
  },
  {
    key: 21,
    name: 'Grain Size',
    namePt: 'Tamanho de Grão',
    type: 3,
    typeCode: 'metallographic',
    id: 'grain_size',
    code: 'test.grain.size',
    sites: ['J', 'B'],
  },
  {
    key: 22,
    name: 'Hardenability',
    namePt: 'Temperabilidade',
    type: 2,
    typeCode: 'mechanical',
    id: 'hardenability',
    code: 'test.hardenability',
    req: [
      'Variação máx (Max Variation)',
      'Dureza máx (Hardness max)',
      'Dureza min (Hardness min)',
    ],
    sites: ['J', 'B'],
  },
  {
    key: 23,
    name: 'Tensile - Transversal',
    namePt: 'Tração Transversal',
    type: 2,
    typeCode: 'mechanical',
    id: 'tensile_transversal',
    code: 'test.tensile.transversal',
    sites: ['J', 'B'],
  },
  {
    key: 24,
    name: 'Tensile - Longitudinal',
    namePt: 'Tração Longitudinal',
    type: 2,
    typeCode: 'mechanical',
    id: 'tensile_longitudinal',
    code: 'test.tensile.longitudinal',
    sites: ['J', 'B'],
  },
  {
    key: 25,
    name: 'Hot Tensile - Transversal',
    namePt: 'Tração Transversal a Quente',
    type: 2,
    typeCode: 'mechanical',
    id: 'tensile_transversal_hot',
    code: 'test.tensile.transversal_hot',
    sites: ['J', 'B'],
  },
  {
    key: 26,
    name: 'Hot Tensile - Longitudinal',
    namePt: 'Tração Longitudinal a Quente',
    type: 2,
    typeCode: 'mechanical',
    id: 'tensile_longitudinal_hot',
    code: 'test.tensile.longitudinal_hot',
    sites: ['J', 'B'],
  },
  {
    key: 27,
    name: 'Micro Cleanliness D',
    namePt: 'Micro Pureza D',
    type: 3,
    typeCode: 'metallographic',
    id: 'micro_cleanliness_d',
    code: 'report.cleanliness_d',
    sites: ['J', 'B'],
  },
  {
    key: 28,
    name: 'Grain Size - Longitudinal',
    namePt: 'Tamanho de Grão Longitudinal',
    type: 3,
    typeCode: 'metallographic',
    id: 'grain_size_longitudinal',
    code: 'test.grain.size.longitudinal',
    sites: ['J', 'B'],
  },
  {
    key: 29,
    name: 'Microstructure with photos - Longitudinal',
    namePt: 'Microestrutura (fotos) - Longitudinal',
    type: 3,
    typeCode: 'metallographic',
    id: 'microstructure_photos_longitudinal',
    code: 'test.microstructure.with.photos.longitudinal',
    sites: ['J', 'B'],
    selectOne: true,
  },
]

export const YES_NO_SELECT = [
  {
    key: 1,
    value: '1',
    label: 'Sim',
  },
  {
    key: 2,
    value: '2',
    label: 'Não',
  },
]

export const TOTAL_PROGRESS = 100
export const DOCUMENT_UPLOAD_CALLS = 5
export const MAX_PROGRESS_INTERVAL = 25

export const TEST_TYPES = [
  'mechanical',
  'metallographic',
  'corrosion',
  'chemical',
  'ndt',
  'collapse',
]

export const DEFAULT_UPLOAD_FILE_TYPES: { [key: string]: string[] } = {
  'application/vnd.ms-excel': ['.xls', '.xlsx'],
  'text/csv': ['.csv'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
}
